import { authAxios as axios } from "shared-auth";
import { useQuery } from "react-query";
import config from "config/global";
import { ISearchCriteria, ISuggestion } from "../types";

const MY_SUGGESTIONS_QUERY_KEY = "MY_SUGGESTIONS_QUERY_KEY";

export function useSearchSuggestions(
  searchCriteria: ISearchCriteria,
  enabled = true
) {
  const { data, isLoading, refetch } = useQuery<{
    suggestions: ISuggestion[];
    total: number;
  }>(
    [MY_SUGGESTIONS_QUERY_KEY, searchCriteria],
    async () => {
      const result = await axios(`${config.suggestionsApiUrl}/suggestions`, {
        params: searchCriteria,
      });

      return result.data;
    },
    { enabled }
  );

  return {
    suggestions: data?.suggestions || [],
    total: data?.total || 0,
    refetch,
    isLoading,
  };
}
